
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/en/docs/komodo-defi-framework/api/v20/streaming/disable",
      function () {
        return require("private-next-pages/en/docs/komodo-defi-framework/api/v20/streaming/disable/index.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/en/docs/komodo-defi-framework/api/v20/streaming/disable"])
      });
    }
  